import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grape } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const origin_url = window.location.origin;
      await api.post("/auth/forgot-password", { email, origin_url });
      setSent(true);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail, t) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 sm:py-24">
      <div className="text-center mb-8">
        <Grape className="h-8 w-8 text-[#4ba3b7] mx-auto mb-3" />
        <h1 className="font-heading text-2xl sm:text-3xl font-bold">{t("auth.resetPasswordTitle")}</h1>
      </div>

      {sent ? (
        <p className="text-center text-sm text-[#2B2B2B]/70" data-testid="forgot-password-sent-message">
          {t("auth.passwordResetSentMessage")}
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="h-12 rounded-xl mt-1.5" data-testid="forgot-password-email-input" />
          </div>
          {error && <p className="text-sm text-[#FF3B30]" data-testid="forgot-password-error-message">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-[#4ba3b7] hover:bg-[#3D8A9A] font-bold" data-testid="forgot-password-submit-button">
            {loading ? t("common.loading") : t("auth.sendResetLink")}
          </Button>
        </form>
      )}

      <p className="text-center text-sm mt-6">
        <Link to="/login" className="text-[#4ba3b7] font-semibold hover:underline" data-testid="forgot-password-back-to-login-link">
          {t("auth.backToLogin")}
        </Link>
      </p>
    </div>
  );
}
